<template>
  <div class="flex justify-between items-center w-full">
    <input
      ref="input"
      :id="$id('keywordSearch')"
      class="flex-grow"
      name="keywordSearch"
      type="text"
      :placeholder="placeholderText"
      v-model="computedValue"
    />
    <a class="icon-container leading-none" @click="submit">
      <i
        class="bdg-icon search ml-2 text-2xl"
        :class="{ 'text-black': !blueIcon, 'text-blue': blueIcon }"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "BdgSearchField",
  props: {
    placeholderText: {
      type: String,
      default: "Search"
    },
    value: String,
    blueIcon: Boolean
  },
  data() {
    return {
      localValue: ""
    };
  },
  computed: {
    computedValue: {
      get() {
        if (this.value) {
          return this.value;
        }
        return this.localValue;
      },
      set(val) {
        this.$emit("input", val);
        this.localValue = val;
      }
    },
    lightTheme() {
      return this.theme !== "dark";
    }
  },
  mounted() {
    document.addEventListener("keyup", this.onKeyUp);
  },
  methods: {
    onKeyUp(event) {
      if (
        this.$el === document.activeElement ||
        this.$refs.input === document.activeElement
      ) {
        if (event.code === "Enter") {
          this.submit();
        }
      }
    },
    submit() {
      this.$emit("search", this.computedValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.height-44 {
  min-height: 44px;
}
</style>
